//export const PROD_API_URL = 'https://localhost:44378'
export const PROD_API_URL = 'https://e-cclesia-web-api.azurewebsites.net/'
export const JWT_TOKEN = 'jwt_token'
export const COOKIE_ROLE = 'role'
export enum RecordTypes {
    'Ingreso' = 1,
    'Egreso' = 2,
}
export const RECEIPT_DATA = 'receiptData'
